import { RootLayout } from '@/layouts/RootLayout'
import { ChangePasswordPage } from '@/pages/ChangePassword'
import { ErrorPage } from '@/pages/Error'
import { HomePage } from '@/pages/Home'
import { ItemsPage } from '@/pages/Items'
import { LoginPage } from '@/pages/Login'
import { ProfileSettingsPage } from '@/pages/ProfileSettings'
import { ReportPage } from '@/pages/Report'
import { RoutePage } from '@/pages/Route'
import { SettingsPage } from '@/pages/Settings'
import { StopPage } from '@/pages/Stop'
import { Styleguide } from '@/pages/Styleguide'
import { ViewReportPage } from '@/pages/ViewReport'
import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom'
import { GuestRoute } from './GuestRoute'
import { ProtectedRoute } from './ProtectedRoute'

// Development-only routes
const devRoutes: RouteObject[] = import.meta.env.DEV
  ? [{ path: 'styleguide', element: <Styleguide /> }]
  : []

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      // Development-only routes (no auth required)
      ...devRoutes,
      {
        element: <GuestRoute />,
        children: [{ path: 'login', element: <LoginPage /> }],
      },
      {
        element: <ProtectedRoute />,
        children: [
          { index: true, element: <HomePage /> },
          { path: 'settings', element: <SettingsPage /> },
          { path: 'change-password', element: <ChangePasswordPage /> },
          { path: 'profile-settings', element: <ProfileSettingsPage /> },
          { path: ':partOfDay', element: <RoutePage /> },
          { path: ':partOfDay/:stop', element: <StopPage /> },
          { path: ':partOfDay/:stop/report', element: <ReportPage /> },
          {
            path: ':partOfDay/:stop/report/view',
            element: <ViewReportPage />,
          },
          { path: ':partOfDay/:stop/items', element: <ItemsPage /> },
        ],
      },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
])
